import { render } from "./income.vue?vue&type=template&id=4ab53b87&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=4ab53b87&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab53b87"]])

export default __exports__